import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppChat = () => {
  const phoneNumber = "919301542085";

  const style = {
    position: "fixed",
    bottom: "25px",
    left: "25px",
    backgroundColor: "#25d366",
    color: "#fff",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "32px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
    zIndex: 99999,
  };

  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      style={style}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp /> {/* This should be a component, not an object */}
    </a>
  );
};

export default WhatsAppChat;